module.exports = __webpack_public_path__ + "static/img/fish9.86b5669.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/starfish/fish9.png
// module id = ZSJM
// module chunks = 0